<template>
  <!-- 新建派车 -->
  <div class="contentBox">
    <el-collapse v-model="activeNames">
      <!-- 运单/订单装载明细 -->
      <el-collapse-item
        name="2"
        class="details_item"
      >
        <template slot="title">
          <div
            :class="isWaybill ? 'active_item' : ''"
            style="padding-right: 10px"
            @click.stop="isWaybill = true"
            v-if="hasPermiss('admin:dispatch:checixiangqing:waybills')"
          >
            运单装载明细
          </div>
          <div
            class="soltTitle"
            :class="!isWaybill ? 'active_item' : ''"
            @click.stop="isWaybill = false"
            v-if="hasPermiss('admin:dispatch:checixiangqing:commands')"
          >
            订单装载明细
          </div>
        </template>
        <waybills
          :dispatchId="dispatchId"
          v-show="isWaybill"
          ref="waybill"
          :op="op"
          :isSee="isSee"
          v-if="hasPermiss('admin:dispatch:checixiangqing:waybills')"
        ></waybills>
        <commands
          v-show="!isWaybill"
          :dispatchId="dispatchId"
          ref="command"
          :op="op"
          :isSee="isSee"
          v-if="hasPermiss('admin:dispatch:checixiangqing:commands')"
        ></commands>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
import paging from "@/components/pagings.vue"; //分页组件
import waybills from "./waybills.vue";
import commands from "./commands.vue";
export default {
  components: {
    paging,
    waybills,
    commands
  },
  props: {
    dispatchId: {
    },
    isSee: {
        
    },
    type: {
      type: String,
      require: false,
      default: "edit",
    },
    op: {
      type: String,
      require: false,
      default: "edit",
    },
  },
  data() {
    return {
      dispatchStatus: "未派车", // 派车状态
      activeNames: ["1", "2", "3"],
      departForm: {
        dispatchNumber: "",
        dispatchType: "",
        planDepartureTime: "",
        startDeptId: "",
        endDeptId: "",
        carCategoryConfDictId: "",
        carNumber: "",
        driverOneId: "",
        driverOneName: "",
        driverOnePhone: "",
        driverOneIdcard: "",
        dispatchContractNumber: "",
        outgoingPersonnelId: "",
        outgoingPersonnelName: "",
        remarks: "",
        totalCount: "",
        totalWeight: "",
        totalVolume: "",
        totalVote: "",
        totalAmount: "",
        route: "",
      },
      dispatchTypes: [],
      businessDepts: [], // 网点
      car_categoryList: [], //车辆分类
      carNumberList: [], // 车牌号
      fileNameLists: [], // 图片列表
      emps: [],
      /**------运单/订单明细表格 */
      isWaybill: true, // 运单/订单明细
      loadingDetails: [], // 运单/订单明细表格data
      pageStart: 1, //  页码
      pageCount: 0, //  总条数
      pageTotal: this.$COMMON.pageTotals, //  一页几条
      tableHeigth: "auto", //  表格高度
      selectTableData: [], //  表格选中的数据
      /**--------- */
      /**-------车次费用表格 */
      trainCostData: [],
      /**--------------- */
      previewSrcList: [],
      showViewer: false,
      carTiming: [],
    };
  },
  computed: {
    editable() {
      return false;
    },
    disabledSee() {
      return !this.editable;
    },
    feeCheckIn() {
      return this.op === "feeCheckIn";
    },
    baseEdit() {
      return this.op === "baseEdit";
    },
    intoStoreage() {
      return this.op === "intoStoreage";
    },
  },
  mounted() {

  },
  watch: {

  },
  methods: {

  },
};
</script>

<style scoped lang="less">
.contentBox {
  padding-bottom: 50px;
  overflow: auto;
  height: 100%;
  .dispatch_head {
    height: 50px;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #ccc;
    .topBtns {
      background-color: #fff;
      margin-top: -10px;
      // height: 50px;
    }
    .waybill_Type {
      // margin-bottom: 10px;
      width: fit-content;
      height: max-content;
      color: #ff0000;
      font-weight: bold;
      border: 2px dashed transparent;
      border-radius: 5px;
      padding: 2px 12px;
      background: linear-gradient(#fff, #fff) padding-box,
        repeating-linear-gradient(
          -75deg,
          #ff0000 0,
          #ff0000 0.9em,
          #fff 0,
          #fff 1.2em
        );
    }
  }

  .infoDiv {
    // border-width: 1px 1px 0 1px;
    // border-style: solid;
    // border-color: #f59a23;
    display: flex;
    .formbox {
      // padding: 0 30px;
      padding: 0 10px;
      // width: calc(100% - 70px);
      width: 100%;
      .glo_formBox {
        // justify-content: space-between;
        .el-form-item {
          margin-right: 1.8%;
        }
        .double_item {
          /deep/.el-form-item__content {
            display: flex;
            .el-select {
              input {
                padding-left: 5px;
              }
            }
            .second_ipt {
              input {
                padding-left: 5px;
                padding-right: 10px;
              }
            }
            .unit {
              margin-right: 5px;
            }
          }
        }
        .Divider {
          width: 100%;
          height: 1px;
          margin-bottom: 10px;
          border-top: 1px dashed transparent;
          background: linear-gradient(#fff, #fff) padding-box,
            repeating-linear-gradient(
              -75deg,
              #797979 0,
              #797979 0.9em,
              #fff 0,
              #fff 1.2em
            );
        }
      }
      .head_formBox {
        justify-content: flex-start;
        margin: 15px 0 5px 0;
        .el-form-item {
          margin-bottom: 10px;
          // width: 18%;
          width: calc(24% - 2px);
          min-width: unset;
        }
      }
      .jsInput {
        .jsBtns {
          height: 30px;
          line-height: 30px;
          margin: 0;
          padding: 0 10px;
          border: none;
        }
      }
    }

    .goodsItmes {
      margin: 10px 0;
      // margin-top: 30px;
      // border-bottom: 4px solid #ccc;
      // padding-bottom: 20px;
    }

    .formBtns {
      height: 30px;
      margin: 0;
      padding: 0 10px;
    }

    .miniInput {
      width: 80px;
      border-left: 1px solid #ccc;
      border-right: 1px solid #ccc;
      margin-right: 2px;

      text-align: center;

      /deep/ .el-input__inner {
        text-align: center !important;
        padding: 0 5px;
      }
    }
  }
  .el-collapse {
    .details_item {
      .el-collapse-item__header {
        .active_item {
          background: #ffffff;
          color: #ef7c0a;
        }
        .soltTitle {
          padding: 0 10px;
        }
      }
    }
  }
  .cost_dia {
    /deep/.el-dialog {
      .glo_dialogForm {
        .diaForm {
          .el-row {
            width: 100%;
            .multipleSelect {
              display: flex;
              /deep/ .el-select {
                flex: 1;
              }
            }
          }
        }
      }
    }
  }
}
</style>